import { useCallback, useState } from "react";
import { toast } from "react-hot-toast";
import { useSupabaseCallback } from "../../../server/supabase/hooks";

import type { UUID } from "../../../utils/uuid";

/**
 * Archives a Survey, as Listen does, closing it too once it's been published, and says how it went.
 * Resolves to whether it was done.
 */
export function useArchiveSurvey(
  id: UUID,
  published: boolean,
): {
  archive: () => Promise<boolean>;
  archiving: boolean;
} {
  const [archiving, setArchiving] = useState(false);

  const archiveCallback = useSupabaseCallback(
    async ({ supabase }): Promise<boolean> => {
      setArchiving(true);
      try {
        const { error } = await supabase.rpc("archive_survey", {
          survey_id_: id,
          close_survey_: published,
        });
        if (error) {
          toast.error(`Something went wrong: ${error.message}`);
          return false;
        }
        toast.success("Survey successfully archived");
        return true;
      } finally {
        setArchiving(false);
      }
    },
    [id, published],
  );

  const archive = useCallback(
    async (): Promise<boolean> => (await archiveCallback()) ?? false,
    [archiveCallback],
  );

  return { archive, archiving };
}
